import React from 'react';
import PropTypes from 'prop-types';

const GradingSection = ({ id, setAnswerCorrect, correct }) => {
  return (
    <>
      <label htmlFor={`answer${id}_correct`}>
        <input
          type="radio"
          id={`answer${id}_correct`}
          value="true"
          onChange={() => setAnswerCorrect('true')}
          checked={String(correct) === 'true'}
        />{' '}
        <span className="ml-8">{t('grades.correct')}</span>
      </label>
      <label htmlFor={`answer${id}_incorrect`}>
        <input
          type="radio"
          id={`answer${id}_incorrect`}
          value="false"
          onChange={() => setAnswerCorrect('false')}
          checked={String(correct) === 'false'}
        />{' '}
        <span className="ml-8">{t('grades.incorrect')}</span>
      </label>
    </>
  );
};

GradingSection.propTypes = {
  id: PropTypes.number,
  setAnswerCorrect: PropTypes.func,
  correct: PropTypes.string,
};

export default GradingSection;
